<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">试卷管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="试卷名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="试卷分类">
          <el-select v-model="formInline.scope" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.dangerCategorys" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.fbzt" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd(() => resetAiConfig())">创建试卷</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="试卷名称" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="status_name" label="状态" width="100">
        </custom-table-column>
        <custom-table-column prop="scope" label="试卷分类" width="100px">
        </custom-table-column>
        <custom-table-column prop="type" label="组卷类型" width="100px">
        </custom-table-column>
        <custom-table-column prop="" label="组织结构">
          <template slot-scope="scope">
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="pass_line" label="及格线" width="80px">
        </custom-table-column>
        <custom-table-column prop="description" label="描述">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handlePreview(scope.row)" type="text" size="small">预览试卷</el-button>
            <el-button @click="handleItems(scope.row)" type="text" size="small">绑定题目</el-button>
            <el-button v-if="scope.row.status == 1" @click="handlePublish(scope.row, 0)" type="text"
              size="small">取消发布</el-button>
            <el-button v-else @click="handlePublish(scope.row, 1)" type="text" size="small">发布</el-button>
            <!-- <el-button v-else-if="scope.row.status == 1" @click="handleDisable(scope.row)" type="text"
              size="small">停用</el-button> -->
            <el-button
              @click="handleEditNew(scope.row, ['id'], () => handleEditCallBackSetStruc({ major: 'structure_2', row: scope.row }))"
              type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <el-dialog :close-on-click-modal="false" title="绑定题目" :visible.sync="detailDialogVisible" width="986px">

        <div>
          <custom-table :data="tableData1" border style="width: 100%;" max-height="500px">
            <custom-table-column fixed label="序号" type="index" width="50">
            </custom-table-column>
            <custom-table-column prop="name" fixed label="题目名称" min-width="160">
            </custom-table-column>
            <custom-table-column prop="type" label="题目类型" width="100">
            </custom-table-column>
            <custom-table-column prop="score" label="分值" width="100">
            </custom-table-column>
            <custom-table-column prop="order" label="排序" width="100">
            </custom-table-column>
            <custom-table-column prop="answers" label="答案" width="160">
              <template slot-scope="scope" v-if="scope.row.answers_array && scope.row.answers_array.length">
                <span>{{ scope.row.answers_array.join(",") }}</span>
              </template>
            </custom-table-column>
            <custom-table-column prop="options" label="选项" min-width="200">
              <template slot-scope="scope" v-if="scope.row.options_array && scope.row.options_array != 'null'">
                <p v-for="item in scope.row.options_array" :key="item.value">{{ item.value }}. {{ item.label }}</p>
              </template>
            </custom-table-column>
            <custom-table-column label="题目配图" min-width="120">
              <template slot-scope="scope">
                <el-image v-if="scope.row.pic && scope.row.pic.indexOf('http') > -1" :src="scope.row.pic"
                  :preview-src-list="scope.row.pic.split(',')" style=" height: 60px;width:auto;margin-right: 4px;">
                </el-image>
                <span v-else>{{ scope.row.pic }}</span>
              </template>
            </custom-table-column>
            <custom-table-column prop="answer_explain" label="答案说明" min-width="220">
            </custom-table-column>
            <custom-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="handleEditItem(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="handleDeletItem(scope.row.paper_question_id)" type="text" size="small">删除</el-button>
              </template>
            </custom-table-column>
          </custom-table>
        </div>
        <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
          <el-form-item>
            <el-button type="primary" @click="handleAddItem">添加题目</el-button>
          </el-form-item>
        </el-form> -->
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleAddItem">添加题目</el-button>
          <el-button @click="detailDialogVisible = false">取 消</el-button>
        </span>
        <el-dialog :close-on-click-modal="false" title="添加题目" :visible.sync="detailInnerDialogVisible" width="746px"
          append-to-body>
          <el-form :model="ruleFormInner" :rules="rulesInner" ref="ruleFormInner" label-width="100px"
            class="demo-ruleForm">
            <div class="add_win ">
              <!-- <p class="add_win_title">隐患上报</p> -->
              <div v-for="(item, index) in ruleFormInner.questions" :key="index" class="add_win_body el-form">
                <el-form-item label="题库">
                  <el-select v-model="item.collection_id" clearable filterable placeholder="请选择题库"
                    @change="handleCollectionChange(item)" style="width:532px;">
                    <el-option v-for="col in collectionItems" :key="col.id" :label="col.name" :value="col.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="题目" :prop="`questions[${index}].questionObjs`">
                  <el-select v-model="item.questionObjs" clearable filterable multiple placeholder="请先选择题库"
                    @change="changeQuestion(item)" value-key="id" style="width:532px;">
                    <el-option v-for="opt in item.questionOptions" :key="opt.id" :label="`(${opt.type})${opt.name}`"
                      :value="opt">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分值" :prop="`questions[${index}].score`">
                  <el-input v-model="item.score" placeholder="请输入" :disabled="item.disabled"
                    style="width:216px;"></el-input>
                  <!-- <div><el-tag type="warning">简答题不能设置分数，默认为0</el-tag></div> -->
                </el-form-item>
                <el-form-item label="排序" :prop="`questions[${index}].order`">
                  <el-input v-model="item.order" placeholder="请输入" style="width:216px;"></el-input>
                </el-form-item>
                <div class="add_win_del">
                  <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
                </div>
              </div>
              <div class="add_win_add">
                <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
              </div>
            </div>
            <el-form-item style="margin-top:8px;width:100%;text-align:right;">
              <el-button type="primary" @click="submitFormByFun('ruleFormInner', linkQuestion)">确认</el-button>
              <el-button @click="resetForm('ruleFormInner')" style="margin-right:24px;">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="编辑" :visible.sync="detailInnerEditDialogVisible" width="526px"
          append-to-body>
          <el-form :model="ruleFormEditInner" :rules="rulesEditInner" ref="ruleFormEditInner" label-width="100px"
            class="demo-ruleForm">
            <el-form-item label="分值" prop="score">
              <el-input v-model="ruleFormEditInner.score" :disabled="ruleFormEditInner.disabled" placeholder="请输入"
                style="width:316px;"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="order">
              <el-input v-model="ruleFormEditInner.order" placeholder="请输入" style="width:316px;"></el-input>
            </el-form-item>
            <el-form-item style="margin-top:8px;width:100%;text-align:right;">
              <el-button type="primary" @click="submitFormByFun('ruleFormEditInner', updateQesInfo)">确认</el-button>
              <el-button @click="resetForm('ruleFormEditInner')" style="margin-right:24px;">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="预览试卷" destroy-on-close :visible.sync="previewDialogVisible"
        width="666px">
        <ExamPage ref="examPage" :key="previewKey" v-if="previewDialogVisible" :formData="formData"></ExamPage>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="试卷名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入" style="width:216px;"></el-input>
          </el-form-item>
          <el-form-item label="试卷分类" prop="scope">
            <el-select v-model="ruleForm.scope" clearable placeholder="请选择" style="width:216px;">
              <el-option v-for="item in $store.state.dangerCategorys" :key="item" :label="item"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组卷类型" prop="type">
            <el-select v-model="ruleForm.type" :disabled="type != 'add'" placeholder="请选择" style="width:216px;">
              <el-option v-for="item in $store.state.paperMakeTypes" :key="item" :label="item"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="试卷类型" prop="type">
            <el-select v-model="ruleForm.type" filterable clearable style="width:216px;" placeholder="请选择">
              <el-option v-for="item in $store.state.paperTypes" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="及格线" prop="pass_line">
            <el-input v-model="ruleForm.pass_line" placeholder="请输入" style="width:216px;"></el-input>
          </el-form-item>
          <el-form-item label="所属组织结构" prop="structure_1">
            <el-input v-model="selectName" placeholder="请选择" style="width:552px;" @focus="dialogOpen"
              @clear="handeleClear" clearable></el-input>
            <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell"
              @handleOrganQuery="handleOrganQueryNew({ limit: false, major: 'structure_2' })">
            </OrganDialog>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input type="textarea" v-model="ruleForm.description" :rows="5" placeholder="请输入"
              style="width:552px;"></el-input>
          </el-form-item>
          <!-- AI组卷配置：与创建试卷同一表单，组卷类型选AI组卷时出现，提交时先建试卷再调AI组卷接口 -->
          <template v-if="showAiConfig">
            <el-divider content-position="left">AI 组卷配置</el-divider>
            <!-- 提示：题目来源与生成依据 -->
            <el-alert type="info" :closable="false" show-icon style="margin-bottom:12px;"
              title="生成依据：安全类型、课程描述、相关题库题目。"
              description="">
            </el-alert>
            <el-form-item label="题目总数">
              <el-input v-model="aiTotalCount" disabled placeholder="请输入" style="width:196px;"></el-input> 题
            </el-form-item>
            <el-form-item label="总分">
              <el-input v-model="aiTotalScore" disabled placeholder="请输入" style="width:196px;"></el-input> 分
            </el-form-item>
            <el-form-item label="单选题" prop="aiConfig.type1">
              <span>数量</span>
              <el-input-number v-model="ruleForm.aiConfig.type1" :min="0" :max="500" size="small"
                style="width:120px;margin:0 8px;"></el-input-number>
              <span>每题分值</span>
              <el-input-number v-model="ruleForm.aiConfig.type1_score" :min="0" :max="100" size="small"
                style="width:120px;margin:0 8px;"></el-input-number>
              <span class="score-tip">小计 {{ aiTypeScore('type1') }} 分</span>
            </el-form-item>
            <el-form-item label="多选题" prop="aiConfig.type2">
              <span>数量</span>
              <el-input-number v-model="ruleForm.aiConfig.type2" :min="0" :max="500" size="small"
                style="width:120px;margin:0 8px;"></el-input-number>
              <span>每题分值</span>
              <el-input-number v-model="ruleForm.aiConfig.type2_score" :min="0" :max="100" size="small"
                style="width:120px;margin:0 8px;"></el-input-number>
              <span class="score-tip">小计 {{ aiTypeScore('type2') }} 分</span>
            </el-form-item>
            <el-form-item label="判断题" prop="aiConfig.type3">
              <span>数量</span>
              <el-input-number v-model="ruleForm.aiConfig.type3" :min="0" :max="500" size="small"
                style="width:120px;margin:0 8px;"></el-input-number>
              <span>每题分值</span>
              <el-input-number v-model="ruleForm.aiConfig.type3_score" :min="0" :max="100" size="small"
                style="width:120px;margin:0 8px;"></el-input-number>
              <span class="score-tip">小计 {{ aiTypeScore('type3') }} 分</span>
            </el-form-item>
            <!-- 题目总数、总分随题型数量与分值自动计算 -->
            <el-form-item label="难度分布" prop="aiConfig.easy">
              <span> 简单</span>
              <el-input-number v-model="ruleForm.aiConfig.easy" :min="0" :max="100" size="small"
                style="width:110px;margin:0 8px;"></el-input-number>
              <span> 中等</span>
              <el-input-number v-model="ruleForm.aiConfig.midding" :min="0" :max="100" size="small"
                style="width:110px;margin:0 8px;"></el-input-number>
              <span> 困难</span>
              <el-input-number v-model="ruleForm.aiConfig.difficulty" :min="0" :max="100" size="small"
                style="width:110px;margin:0 8px;"></el-input-number>
              <el-tag :type="aiDifficultySum == 100 ? 'success' : 'danger'" size="small">合计 {{ aiDifficultySum
                }}%</el-tag>
            </el-form-item>
          </template>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" v-if="type == 'add'"
              @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
            <el-button type="primary" v-if="type == 'edit'"
              @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
            <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- AI组卷进度动画：先创建试卷，再调AI组卷接口 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="AI 智能组卷"
      :visible.sync="aiProgressVisible" width="520px" :show-close="aiProgressStatus != 'processing'" append-to-body>
      <div style="padding:10px 0 20px;text-align:center;">
        <el-steps :active="aiProgressStep" finish-status="success"
          :process-status="aiProgressStatus == 'error' ? 'error' : 'process'" align-center>
          <el-step title="创建试卷" :description="aiProgressStep >= 0 ? aiStepTexts[0] : ''"></el-step>
          <el-step title="AI 抽题组卷" :description="aiProgressStep >= 1 ? aiStepTexts[1] : ''"></el-step>
          <el-step title="完成" :description="aiProgressStep >= 2 ? aiStepTexts[2] : ''"></el-step>
        </el-steps>
        <div style="margin-top:26px;">
          <i v-if="aiProgressStatus == 'processing'" class="el-icon-loading" style="font-size:36px;color:#409EFF;"></i>
          <i v-else-if="aiProgressStatus == 'success'" class="el-icon-circle-check"
            style="font-size:36px;color:#67C23A;"></i>
          <i v-else-if="aiProgressStatus == 'error'" class="el-icon-circle-close"
            style="font-size:36px;color:#F56C6C;"></i>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="aiProgressStatus != 'processing'">
        <el-button type="primary" @click="aiProgressVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import ExamPage from "@/components/examPage";

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan, mixinValidate],
  data() {
    return {
      formInline: {
        name: '',
        scope: '',
        status: '',
      },
      formInline1: {
        paper_id: '',
        structure_1: '',
        structure_2: '',
      },
      formData: {
      },
      ruleForm: {
        name: '',
        type: '人工组卷',
        scope: '',
        pass_line: 60,
        description: '',
        structure_1: "",
        structure_2: "",
        // AI组卷配置：字段与 api/new/paper-questions/AIstore 的参数一一对应
        // 必须挂在 ruleForm 下，el-form-item 的嵌套 prop 才能解析到（提交创建试卷接口时会剔除）
        aiConfig: {
          type1: 10,
          type1_score: 2,
          type2: 25,
          type2_score: 2,
          type3: 10,
          type3_score: 3,
          easy: 30,
          midding: 50,
          difficulty: 20
        },
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        pass_line: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkfloat, trigger: 'blur' }],
        // structure_1: [{ required: true, message: '请选择' }],
        // AI组卷配置校验（人工组卷时默认值也满足，不会误报）
        'aiConfig.type1': [{ validator: this.checkAiTypeCount, trigger: 'change' }],
        'aiConfig.easy': [{ validator: this.checkAiDifficulty, trigger: 'change' }],
      },
      ruleFormInner: {
        paper_id: '',
        questions: [{
          collection_id: '',
          questionOptions: [],
          questionObjs: [],
          score: 0,
          disabled: false,
          order: 10
        }]
      },
      // 题库列表(题目按题库筛选后再拉)
      collectionItems: [],
      rulesInner: {},
      ruleFormEditInner: {
        id: '',
        score: '',
        order: '',
        type: '',
        disabled: false,
      },
      rulesEditInner: {
        collection_id: [{ required: true, message: '请选择', trigger: 'change' }],
        score: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkfloat, trigger: 'blur' }],
        order: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }]
      },
      previewDialogVisible: false,
      previewKey: 0, // 每次预览自增,强制重建 ExamPage(规避 el-dialog 内容组件挂载时序问题)
      detailDialogVisible: false,
      detailInnerDialogVisible: false,
      detailInnerEditDialogVisible: false,
      tableData1: [],
      // AI组卷进度动画
      aiProgressVisible: false,
      aiProgressStep: 0,
      aiProgressStatus: '',
      aiStepTexts: ['正在创建试卷...', '正在从题库抽取题目...', '组卷完成']
    };
  },
  components: {
    ExamPage
  },
  computed: {
    // AI组卷配置区：创建的AI组卷试卷才展示（aibtn 权限沿用原AI按钮的判断）
    showAiConfig() {
      return this.type == 'add' && this.ruleForm.type == 'AI组卷' && !this.$until.checkPrmissions('questionManage', 'aibtn');
    },
    // 题目总数：三种题型数量之和
    aiTotalCount() {
      return Number(this.ruleForm.aiConfig.type1 || 0) + Number(this.ruleForm.aiConfig.type2 || 0) + Number(this.ruleForm.aiConfig.type3 || 0);
    },
    // 总分：各题型数量 × 每题分值
    aiTotalScore() {
      return this.aiTypeScore('type1') + this.aiTypeScore('type2') + this.aiTypeScore('type3');
    },
    aiDifficultySum() {
      return Number(this.ruleForm.aiConfig.easy || 0) + Number(this.ruleForm.aiConfig.midding || 0) + Number(this.ruleForm.aiConfig.difficulty || 0);
    }
  },
  created() {
  },
  mounted() {
    this.setRules();
    this.$store.dispatch('getDangerCategorys');
  },
  methods: {
    changeQuestion(question) {
      if (question.questionObjs.some(item => item.type == '简答题')) {
        question.disabled = true
        question.score = 0
      } else {
        question.disabled = false
      }
    },
    handleEditItem(row) {
      this.detailInnerEditDialogVisible = true
      this.ruleFormEditInner = {
        id: row.paper_question_id,
        score: row.score,
        order: row.order,
        type: row.type,
        disabled: false
      }
      if (row.type == "简答题") {
        this.ruleFormEditInner.score = 0
        this.ruleFormEditInner.disabled = true
      }
    },
    async updateQesInfo() {
      let params = {
        score: this.ruleFormEditInner.score,
        order: this.ruleFormEditInner.order,
      };
      let res = await this.$api.instance.interfaceServer(`api/new/paper-questions/update/${this.ruleFormEditInner.id}`, 'get', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
      }
      this.detailInnerEditDialogVisible = false
      this.ruleFormEditInner = {
        id: '',
        score: '',
        order: '',
        type: '',
        disabled: false,
      }
      this.getList1()
    },
    async linkQuestion() {
      let params = {
        paper_id: this.formInline1.paper_id,
        questions: []
      }
      if (this.ruleFormInner.questions.length) {
        this.ruleFormInner.questions.map(qes => {
          qes.questionObjs.map(q => {
            params.questions.push({
              question_id: q.id,
              score: qes.score,
              order: qes.order
            })
          })
        })
      }
      let res = await this.$api.instance.interfaceServer('api/new/paper-questions/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '绑定成功！',
        });
        this.detailInnerDialogVisible = false
        this.ruleFormInner = {
          paper_id: '',
          questions: [{
            collection_id: '',
            questionOptions: [],
            questionObjs: [],
            score: 0,
            disabled: false,
            order: 10
          }]
        }
        this.handleQuery1()
      }
    },
    // 打开"添加题目":先拉题库列表(题目按题库筛选后再拉)
    async handleAddItem() {
      this.detailInnerDialogVisible = true
      let res = await this.$api.instance.interfaceServer('api/new_course/collection/list', 'get', { page: 1, size: 999 });
      if (res.code == 0 && res.data) {
        this.collectionItems = res.data.data.map(item => ({ id: item.id, name: item.name }))
      }
    },
    // 切换题库:拉该题库的题目,并排除本试卷已绑定的题目
    async handleCollectionChange(item) {
      item.questionObjs = []
      item.questionOptions = []
      if (!item.collection_id) return
      let res = await this.$api.instance.interfaceServer('api/new/question/list', 'get', {
        collection_id: item.collection_id,
        page: 1,
        size: 999
      });
      if (res.code == 0 && res.data) {
        let boundIds = this.tableData1.map(row => String(row.question_id))
        item.questionOptions = res.data.data
          .filter(q => boundIds.indexOf(String(q.id)) === -1)
          .map(q => ({ id: q.id, name: q.name, type: q.type }))
      }
    },
    handleItemDelete(item, index) {
      this.ruleFormInner.questions.splice(index, 1);
      this.setRules()
    },
    handleItemAdd() {
      this.ruleFormInner.questions.push({
        collection_id: '',
        questionOptions: [],
        questionObjs: [],
        score: 0,
        disabled: false,
        order: (this.ruleFormInner.questions.length + 1) * 10
      });
      this.setRules()
    },
    setRules() {
      this.rulesInner = {
        ...this.generateArrRules()
      };
    },
    generateArrRules() {
      const arrRules = {};
      this.ruleFormInner.questions.forEach((item, index) => {
        arrRules[`questions[${index}].questionObjs`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
        arrRules[`questions[${index}].score`] = [
          { required: true, message: `请输入`, trigger: 'blur' }, { validator: this.checkfloat, trigger: 'blur' }
        ];
      });
      return arrRules;
    },
    handleItems(row) {
      this.formInline1.paper_id = this.ruleFormInner.paper_id = row.id
      this.formInline1.structure_1 = row.structure_1
      this.formInline1.structure_2 = row.structure_2
      this.tableData1 = []
      this.detailDialogVisible = true;
      this.handleQuery1()
    },
    handleDeletItem(id) {
      this.confirmBox('warning', `此操作将删除该题目，是否继续`, { id }, this.deleteItem);
    },
    async deleteItem(params) {
      let res = await this.$api.instance.interfaceServer(`api/new/paper-questions/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.getList1();
      }
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.getList1();
      });
    },

    async getList1() {
      const params = this.$until.deleteNullPrototype(this.formInline1);
      let res = await this.$api.instance.interfaceServer(`api/new/paper-questions/list`, 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data;
      }
    },
    async handlePreview(row) {
      let res = await this.$api.instance.interfaceServer(`api/new/paper/detail/${row.id}/0`, 'get');
      if (res.code == 0 && res.data) {
        this.formData = res.data
        this.previewKey++ // 强制重建 ExamPage,保证其挂载时 formData 已就绪
        // this.formData.name = row.name
        // this.formData.configs = row.content ? JSON.parse(row.content) : []
        this.previewDialogVisible = true;
      }
      // if (row.content) {
      //   this.formData.name = row.name
      //   this.formData.configs = row.content ? JSON.parse(row.content) : []
      // }
      // this.previewDialogVisible = true;
    },
    handleSetVal(row) {
    },
    // 发布试卷(status==0 未发布时可发布)
    publishMethod(params) {
      this.$api.instance.interfaceServer(`api/new/paper/status/submit/${params.id}`, 'put', { status: params.status }).then(res => {
        if (res.code == 0) {
          this.$message({ type: 'success', center: true, message: '设置成功！' });
          this.handleQuery();
        }
      });
    },
    handlePublish(row, status) {
      this.confirmBox('success', `是否发布试卷《${row.name}》？`, { id: row.id, status }, this.publishMethod);
    },
    // 停用试卷(status==1 已发布时可停用)
    disableMethod(id) {
      this.$api.instance.interfaceServer(`api/new/paper/status/update/${id}`, 'put').then(res => {
        if (res.code == 0) {
          this.$message({ type: 'success', center: true, message: '停用成功！' });
          this.handleQuery();
        }
      });
    },
    handleDisable(row) {
      this.confirmBox('warning', `是否停用试卷《${row.name}》？`, row.id, this.disableMethod);
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new/paper/delete/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    // AI组卷配置恢复默认值（每次打开创建弹窗时重置）
    resetAiConfig() {
      this.ruleForm.aiConfig = {
        type1: 10,
        type1_score: 2,
        type2: 25,
        type2_score: 2,
        type3: 10,
        type3_score: 3,
        easy: 30,
        midding: 50,
        difficulty: 20
      };
    },
    // 单题型小计分值
    aiTypeScore(prefix) {
      return Number(this.ruleForm.aiConfig[prefix] || 0) * Number(this.ruleForm.aiConfig[`${prefix}_score`] || 0);
    },
    // 至少配置一种题型的数量
    checkAiTypeCount(rule, value, callback) {
      if (this.aiTotalCount <= 0) {
        callback(new Error('请至少配置一种题型的数量'));
        return;
      }
      callback();
    },
    // 难度百分比之和必须为100%
    checkAiDifficulty(rule, value, callback) {
      if (this.aiDifficultySum !== 100) {
        callback(new Error('难度分布百分比之和必须为100%'));
        return;
      }
      callback();
    },
    // 进度动画的停顿，避免接口太快看不到组卷过程
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async createMethod() {
      let isAi = this.showAiConfig;
      let aiParams = {
        type1: this.ruleForm.aiConfig.type1,
        type1_score: this.ruleForm.aiConfig.type1_score,
        type2: this.ruleForm.aiConfig.type2,
        type2_score: this.ruleForm.aiConfig.type2_score,
        type3: this.ruleForm.aiConfig.type3,
        type3_score: this.ruleForm.aiConfig.type3_score,
        easy: this.ruleForm.aiConfig.easy,
        midding: this.ruleForm.aiConfig.midding,
        difficulty: this.ruleForm.aiConfig.difficulty
      };
      if (isAi) {
        this.aiProgressVisible = true;
        this.aiProgressStep = 0;
        this.aiProgressStatus = 'processing';
        await this.sleep(600);
      }
      // 第一步：创建试卷（AI组卷配置不属于创建试卷接口的字段，提交前剔除）
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      delete params.aiConfig;
      let res = await this.$api.instance.interfaceServer('api/new/paper/store', 'post', params);
      if (!res || res.code != 0) {
        if (isAi) this.aiProgressStatus = 'error';
        return;
      }
      this.$message({
        type: 'success',
        center: true,
        message: '提交成功！',
      });
      this.clearState();
      this.resetAiConfig();
      if (!isAi) return;
      let paperId = res.data && res.data.id ? res.data.id : null;
      if (!paperId) {
        this.aiProgressStatus = 'error';
        this.$message({ type: 'error', center: true, message: '创建试卷失败，无法获取试卷ID' });
        return;
      }
      // 第二步：拿试卷ID调AI组卷接口
      this.aiProgressStep = 1;
      await this.sleep(600);
      let aiRes = await this.$api.instance.interfaceServer('api/new/paper-questions/AIstore', 'post',
        Object.assign({ paper_id: paperId }, aiParams));
      if (!aiRes || aiRes.code != 0) {
        this.aiProgressStatus = 'error';
        return;
      }
      // // 后端返回的 data 是本次生成的题目；为空说明没抽到题（参数或题库原因），不能当作成功
      // if (Array.isArray(aiRes.data) && !aiRes.data.length) {
      //   this.aiProgressStatus = 'error';
      //   this.$message({ type: 'warning', center: true, message: '试卷已创建，但AI未抽取到题目，请检查题型数量、难度设置与题库数据' });
      //   this.handleQuery();
      //   return;
      // }
      this.aiProgressStep = 3;
      this.aiProgressStatus = 'success';
      this.$message({
        type: 'success',
        center: true,
        message: 'AI组卷完成！'
      });
      this.handleQuery();
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      delete params.aiConfig;
      let res = await this.$api.instance.interfaceServer(`api/new/paper/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      // let res = await this.$api.instance.interfaceServer('api/questionnaire/list', 'get', params);
      let res = await this.$api.instance.interfaceServer('api/new/paper/lists', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },

  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.score-tip {
  color: #909399;
}
</style>
